<template>
  <ul
    class="background hidden md:block overflow-hidden fixed h-[calc(100%-96px)] top-48px right-0 z-0"
    :class="{ 'w-[calc(100%-80px)]': collapsed, 'w-[calc(100%-300px)]': !collapsed }"
  >
    <li></li>
    <li></li>
    <li></li>
    <li></li>
    <li></li>
    <li></li>
    <li></li>
    <li></li>
    <li></li>
    <li></li>
  </ul>
</template>
<script setup lang="ts">
const collapsed = inject("collapsed") as Ref<boolean>;
</script>
<style>
@keyframes animate {
  0% {
    transform: translateY(0) rotate(0deg);
    opacity: 1;
    border-radius: 0;
  }

  100% {
    transform: translateY(-1000px) rotate(720deg);
    opacity: 0;
    border-radius: 50%;
  }
}
</style>
<style scoped>
.background li {
  position: absolute;
  display: block;
  list-style: none;
  width: 20px;
  height: 20px;
  background: rgba(0, 0, 0, 0.04);
  animation: animate 12s linear infinite;
}

.background li:nth-child(0) {
  left: 70%;
  width: 122px;
  height: 122px;
  bottom: -122px;
  animation-delay: 1s;
}

.background li:nth-child(1) {
  left: 26%;
  width: 45px;
  height: 45px;
  bottom: -45px;
  animation-delay: 2s;
}

.background li:nth-child(2) {
  left: 17%;
  width: 66px;
  height: 66px;
  bottom: -66px;
  animation-delay: 5s;
}

.background li:nth-child(3) {
  left: 42%;
  width: 37px;
  height: 37px;
  bottom: -37px;
  animation-delay: 5s;
}

.background li:nth-child(4) {
  left: 42%;
  width: 55px;
  height: 55px;
  bottom: -55px;
  animation-delay: 4s;
}

.background li:nth-child(5) {
  left: 90%;
  width: 35px;
  height: 35px;
  bottom: -35px;
  animation-delay: 6s;
}

.background li:nth-child(6) {
  left: 18%;
  width: 65px;
  height: 65px;
  bottom: -65px;
  animation-delay: 10s;
}

.background li:nth-child(7) {
  left: 32%;
  width: 60px;
  height: 60px;
  bottom: -60px;
  animation-delay: 12s;
}

.background li:nth-child(8) {
  left: 27%;
  width: 75px;
  height: 75px;
  bottom: -75px;
  animation-delay: 8s;
}

.background li:nth-child(9) {
  left: 66%;
  width: 37px;
  height: 37px;
  bottom: -37px;
  animation-delay: 6s;
}
</style>
